import { buildRoute } from '@direct-frontend/modules-router';
import { API_BUSINESS_REQUEST_BASE_PATH } from '../../api/requests';

/** роут скачивания списка клиентов в csv xlsx */
export const clientsExportRoute = buildRoute(API_BUSINESS_REQUEST_BASE_PATH + '/users/export');
